<template>
	<div class="tempD">
		<div class="pageTit"><span @click="goHome">1522只智能设计之家首页</span> > <span>更多设计案例</span></div>
		<div class="designCase_arr">
			<div class="masonry">
				<div class="item" v-if="loading" v-for="ai,index in anliArr" @click="seePhoto(ai)">
					<div class="item_content content-lar">
						<img :src="imgAPI+ai.imgUrlArr[0]" />
						<div class="userInfo">
							<div class="usphoto">
								<img :src="imgAPI+ai.headimg" />
							</div>
							<div class="usname">{{ai.nickname}}</div>
						</div>
					</div>
				</div>
				<!-- more items -->
			</div>

		</div>
		<el-dialog title="" :show-close="false" :visible.sync="seePhotoDlog" class="myDlog myDlog_opa" :fullscreen="true">
			<worksInfoDlog :pageParams="pageParams" v-on:parentMethod="communication" v-if="seePhotoDlog"></worksInfoDlog>
		</el-dialog>
	</div>
</template>

<script>
	import baseConst from '../../../assets/js/baseConst.js' //注意路
	const worksInfoDlog = () =>
		import("@/components/home/works/works_info.vue"); //作品详情
	export default {
		components: {
			worksInfoDlog
		},
		data() {
			return {
				anliArr: [],
				pageParams: {}, //页面传参参数
				imgAPI: '',
				loading: false,
				pageNumber: 2,
				total:0,
				lastPage:false,
				seePhotoDlog: false,
			}
		},
		created: function() {
			let _this = this;
			_this.imgAPI = baseConst.IMG_API;
			_this.getDesignLise();
			window.onscroll = function() {   //变量scrollTop是滚动条滚动时，距离顶部的距离 
				let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;   //变量windowHeight是可视区的高度  
				let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;   //变量scrollHeight是滚动条的总高度 
				let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;         //滚动条到底部的条件    
				if(scrollHeight - (scrollTop + windowHeight) <1) {         //写后台加载数据的函数
					//console.log("距顶部" + scrollTop + "可视区高度" + windowHeight + "滚动条总高度" + scrollHeight);       
					if (!_this.lastPage) {
						_this.pageNumber += 1;
						_this.getDesignLise();
					}
				}      
			}
		},
		mounted: function() {
			let _this = this;
			_this.setTempDH();
			
		},
		methods: {
			/**  * -----s设置高度    
			 * @version 1.0  * @author 您的大名 2019年12月2日  * */
			setTempDH() {
				let offsetHeight = document.documentElement.clientHeight;
				document.getElementsByClassName("tempD")[0].style.minHeight = offsetHeight + 'px';
			},
			/**  * -----去往首页     * @version 1.0  * @author 您的大名 2019年12月3日  * */
			goHome() {
				let _this = this;
				_this.$router.push('homePage');
			},
			/*获取设计案例
			 创建于2019-11-25  作者：郑凯*/
			getDesignLise() {
				let _this = this;
				let params = {
					limit: 20,
					pageNumber: _this.pageNumber
				};
				_this.getApi('/api/getDesignWorksList', params)
					.then((res) => {
						console.log(res)
						if(res.status == '00') {
							_this.pageNumber = res.data.pageNumber;
							_this.total = res.data.total;
							if (_this.total/20 < 1 || _this.total/20<_this.pageNumber) {
								_this.lastPage = true;
							}
							if(_this.pageNumber>2){
								_this.anliArr = _this.anliArr.concat(res.data.data);
							}else{
								_this.anliArr = res.data.data;
							}
							for(let i = 0; i < _this.anliArr.length; i++) {
								let imgUrlArr = [];
								imgUrlArr = _this.anliArr[i].works.split('|');
								_this.anliArr[i].imgUrlArr = imgUrlArr;
							}
							_this.loading = true;
							let offsetWidth = document.documentElement.clientWidth / 3;
							_this.swiperH = offsetWidth;
						} else {
							_this.$message.error(res.message);
							return;
						}
					})
					.catch((err) => {})
			},
			/**  * -----查看图片
			 * @version 1.0  * @author 您的大名 2019年11月21日  * */
			seePhoto(obj) {
				let _this = this;
				_this.pageParams = JSON.parse(JSON.stringify(obj));
				_this.seePhotoDlog = true;
				setTimeout(function() {
					document.getElementsByClassName("el-dialog__body")[0].scrollTop = 0;
				}, 100)
			},
			/**  * -----这个组件的子组件通信处理    
			 * @version 1.0  * @author 您的大名 2019年12月2日  * */
			communication(type) {
				let _this = this;
				switch(type) {
					case 'works_info':
						_this.seePhotoDlog = false;
						break;
					default:
				}
			},
		}
	}
</script>

<style scoped>
	.tempD {
		width: 100%;
		padding: 0 0.5rem;
		box-sizing: border-box;
		margin: auto;
		background-image: url(../../../../public/img/001.jpg);
		background-size: cover;
		background-repeat: no-repeat;
	}
	
	.pageTit {
		height: 5rem;
		line-height: 5rem;
		border-bottom: 1px solid #ccc;
	}
	
	.pageTit span:nth-child(1) {
		font-weight: bold;
		cursor: pointer;
	}
	
	.pageTit span:nth-child(2) {
		color: #7D7D7D;
	}
	
	.masonry {
		-moz-column-count: 5;
		/* Firefox */
		-webkit-column-count: 5;
		/* Safari 和 Chrome */
		column-count: 5;
		-moz-column-gap: 0.5em;
		-webkit-column-gap: 0.5em;
		column-gap: 0.5em;
		width: 100%;
		margin: 0.1em auto;
		padding-bottom: 1rem;
	}
	
	.item {
		margin-bottom: 1em;
		-moz-page-break-inside: avoid;
		-webkit-column-break-inside: avoid;
		break-inside: avoid;
		/*background: #f60;*/
		background-color: rgb(220, 220, 220);
		cursor: pointer;
	}
	
	.masonry .item:hover {
		box-shadow: 0px 0px 5px #ccc;
		transform: scale(1.03);
	}
	
	.item_content img {
		width: 100%;
		display: block;
	}
	
	@media screen and (max-width: 800px) {
		.masonry {
			column-count: 5;
		}
	}
	
	@media screen and (max-width: 500px) {
		.masonry {
			column-count: 5;
		}
	}
	
	.designTeam_arr .designTeam_arr_item {
		width: 20%;
	}
	
	.userPotot {
		width: 150px;
		height: 150px;
		background-color: red;
		border-radius: 50%;
		margin: auto;
		overflow: hidden;
	}
	
	.userPotot img {
		width: 100%;
	}
	
	.userName {
		text-align: center;
		padding: 20px 0;
		padding-bottom: 30px;
		font-weight: bold;
	}
	
	.userInfo {
		width: 100%;
		display: flex;
		flex-direction: row;
		padding: 10px;
	}
	
	.usphoto {
		width: 40px;
		height: 40px;
		border-radius: 50%;
		background-color: #fff;
		overflow: hidden;
	}
	
	.usname {
		display: flex;
		align-items: center;
		padding-left: 15px;
	}
	
	.imgD {
		width: 70%;
		min-height: 100px;
		margin: auto;
		display: flex;
		flex-direction: row;
	}
	
	.imgD .imgD_left {
		width: 70%;
		box-shadow: 0 0 8px #ccc;
		padding: 15px;
		background-color: #fff;
	}
	
	.imgD .imgD_left img {
		width: 100%;
	}
	
	.imgD .imgD_right {
		flex: 1;
		margin-left: 20px;
	}
	
	.photoTime {
		background-color: #fff;
		box-shadow: 0 0 8px #ccc;
		padding: 5px;
	}
	
	.uutime {
		padding: 5px 0;
		color: #ccc;
		margin-top: 8px;
	}
	
	.myDlog .el-dialog__wrapper {
		background-color: rgba(255, 255, 255, 0.8);
	}
	
	.seemoreDe {
		height: 5rem;
		text-align: center;
		font-size: 20px;
		line-height: 5rem;
		margin-top: 20px;
	}
</style>